import TransactionActionTypes from "./transaction.types";
import {
  getTokenData,
  getTransactionDataByVerificationCode,
  updateTransactionWithSignedData,
  sendSignedDataToIntegration,
  prepareSigningData,
} from "../../services/server-api/server-api.service";
import { sendToLocalSigner } from "../../services/local-signer-api/local-signer-api.service";
import { cloudSign } from "../../services/cloud-signer-api/cloud-signer-api.service";
import {
  getUserCertificateFromLocalSigner,
  sendHashToCloudSign,
  sendHashToSign,
} from "../../services/other-tsp-api.service.js/other-tsp-api.service";

import crypto from "crypto-js";

const fetchTransactionRequest = () => ({
  type: TransactionActionTypes.FETCH_TRANSACTION_REQUEST,
});

const fetchTransactionSuccess = (data) => ({
  type: TransactionActionTypes.FETCH_TRANSACTION_SUCCESS,
  payload: data,
});

const fetchTransactionFailure = (error) => ({
  type: TransactionActionTypes.FETCH_TRANSACTION_FAILURE,
  payload: error,
});

const sendToEsignerRequest = () => ({
  type: TransactionActionTypes.SEND_TO_ESIGNER_REQUEST,
});

const sendToEsignerSuccess = () => ({
  type: TransactionActionTypes.SEND_TO_ESIGNER_SUCCESS,
});

const sendToEsignerFinish = (data) => ({
  type: TransactionActionTypes.SEND_TO_ESIGNER_FINISH,
  payload: data,
});

const sendToEsignerFailure = (error) => {
  return {
    type: TransactionActionTypes.SEND_TO_ESIGNER_FAILURE,
    payload: error,
  };
};

const sendToEmbeddingApiRequest = () => ({
  type: TransactionActionTypes.SEND_TO_EMBEDDING_API_REQUEST,
});

const sendToEmbeddingApiSuccess = (data) => ({
  type: TransactionActionTypes.SEND_TO_EMBEDDING_API_SUCCESS,
  payload: data,
});

const sendToEmbeddingApiFailure = (error) => ({
  type: TransactionActionTypes.SEND_TO_EMBEDDING_API_FAILURE,
  payload: error,
});

export const fetchTransactionData = (token) => {
  return async (dispatch) => {
    dispatch(fetchTransactionRequest());
    try {
      const data = await getTokenData(token);
      dispatch(fetchTransactionSuccess(data));
    } catch (error) {
      dispatch(
        fetchTransactionFailure({ message: error.message, data: error.data })
      );
    }
  };
};

export const fetchTransactionDataByVerificationCode = (verificationCode) => {
  return async (dispatch) => {
    dispatch(fetchTransactionRequest());
    try {
      const data = await getTransactionDataByVerificationCode(verificationCode);
      dispatch(fetchTransactionSuccess(data));
    } catch (error) {
      dispatch(
        fetchTransactionFailure({ message: error.message, data: error.data })
      );
    }
  };
};

export const sendDataToLocalSigner = (data, selectedTsp) => {
  return async (dispatch, getState) => {
    dispatch(sendToEsignerRequest());

    try {
      const { value, signUrl } = selectedTsp;
      const response = await sendToLocalSigner(data, signUrl);
      // tu treba napraviti slanje na pades....
      dispatch(sendToEsignerFinish(response));
      // ovdje pokrenuti spiner....
      const transaction = getState().transaction;

      // fali jos upis u bazu updatDBwithSignData
      const { token, userCert, documents, signDocumentURL, successURL, errorURL, downloadURL  } = transaction.data;
      const sigData = {
        token,
        userCertificate: userCert,
        documents,
        signDocumentURL,
        successURL,
        errorURL,
        downloadURL,
        tspId: value,
      };
      //await updateTransactionWithSignedData(sigData)
      // šaljem cijeli transaction
      dispatch(sendDataToEmbeddedAPI(sigData));
      dispatch(sendToEsignerSuccess());
    } catch (error) {
      dispatch(
        sendToEsignerFailure({ message: error.message, data: error.data })
      );
    }
  };
};

// cloud sign proces se mijennja cijeli....
export const sendDataToCloudSigner = (data, selectedTsp) => {
  return async (dispatch, getState) => {
    dispatch(sendToEsignerRequest());

    try {
      const { value, signUrl } = selectedTsp;
      const response = await cloudSign(data, signUrl);
      // tu treba napraviti slanje na pades....
      dispatch(sendToEsignerSuccess(response));

      const transaction = getState().transaction;

      const { token, mimetype,  signDocumentURL, successURL, errorURL, downloadURL } = transaction.data;
      const { userCertificate, documents } = response;

      const sigData = {
        token,
        userCertificate,
        documents,
        mimetype,
        signDocumentURL, 
        successURL, 
        errorURL, 
        downloadURL ,
        tspId: value,
      };

      dispatch(sendDataToEmbeddedAPI(sigData));
    } catch (error) {
      dispatch(
        sendToEsignerFailure({ message: error.message, data: error.data })
      );
    }
  };
};

export const sendDataToOtherLocalSigner = (data, selectedTsp) => {
  return async (dispatch) => {
    dispatch(sendToEsignerRequest());
    try {
      // get cert
      const { value, signUrl, userInfoUrl } = selectedTsp;
      const userCertificate = await getUserCertificateFromLocalSigner(
        userInfoUrl
      );
      // prepare pdf hash
      const { documents, mimetype, token,  signDocumentURL, successURL, errorURL, downloadURL   } = data;

      const prepSigData = await prepareSigningData({
        token,
        userCertificate,
        documents,
        mimetype,
      });

      const prepData = {
        ...prepSigData,
        token,
      };

      const signData = await sendHashToSign(prepData, signUrl);
      const updateData = {
        ...signData,
        token,
        signDocumentURL, 
        successURL, 
        errorURL, 
        downloadURL,
        tspId: value,
      };

      dispatch(sendDataToEmbeddedAPI(updateData));
      dispatch(sendToEsignerSuccess());
    } catch (error) {
      dispatch(
        sendToEsignerFailure({ message: error.message, data: error.data })
      );
    }
  };
};

export const sendDataToOtherCloudSigner = (data, selectedTsp) => {
  return async (dispatch, getState) => {
    dispatch(sendToEsignerRequest());
    try {
      const { value, signUrl } = selectedTsp;
     
      const transaction = getState().transaction;

      const { token,  signDocumentURL, successURL, errorURL, downloadURL  } = transaction.data;
      const { accessToken, certificateId, certificate, documents, password, salt, mimetype } = data;
      
      const prepSigData = await prepareSigningData({
        userCertificate: certificate,
        documents,
        mimetype,
      });

     
      const hexkey = crypto.SHA256(certificateId).toString();
      const key = crypto.enc.Hex.parse(hexkey);
      const iv = crypto.enc.Hex.parse(salt);
      const encryptedPass = crypto.AES.encrypt(password, key, { iv: iv });

      const prepData = {
        ...prepSigData,
        accessToken,
        token,
        cert_id: certificateId,
        password: encryptedPass.ciphertext.toString(),
      };

      const signData = await sendHashToCloudSign(prepData, signUrl);
      const updateData = {
        ...signData,
        token,
        signDocumentURL, 
        successURL, 
        errorURL, 
        downloadURL,
        tspId: value,
      };

      dispatch(sendDataToEmbeddedAPI(updateData));
      dispatch(sendToEsignerSuccess());
    } catch (error) {
      dispatch(
        sendToEsignerFailure({ message: error.message, data: error.data })
      );
    }
  };
};

export const sendDataToEmbeddedAPI = (data, updateTransaction = true) => {
  return async (dispatch, getState) => {
    dispatch(sendToEmbeddingApiRequest());
    try {
      if (updateTransaction) {
        await updateTransactionWithSignedData(data);
      }

      const APIresponse = await sendSignedDataToIntegration(data);

      dispatch(sendToEmbeddingApiSuccess(APIresponse));
      window.location.replace(
        getState().transaction.data.successURL +
          getState().transaction.data.token
      );
    } catch (error) {
      dispatch(
        sendToEmbeddingApiFailure({ message: error.message, data: error.data })
      );
    }
  };
};
